<!-- Pure overlay spinner - Zero layout impact -->
<div
  *ngIf="loading$ | async"
  class="spinner-overlay"
  role="status"
  aria-live="polite"
  aria-label="Loading">

  <div class="spinner-content">
    <c11n-spinner class="c11n-spinner" [size]="'medium'"
                  [colorMode]="'on-light'" [spinnerStatus]="'Loading...'"
    >
      Loading...
    </c11n-spinner>
  </div>
</div>
